const TaxLine = ({
  isBundlePricing,
  currencySymbol,
  amount,
  currency,
  currencySymbolPlacement
}) => {
  const text = 'Taxes, fees & port expenses'
  const isBundlePricingText = isBundlePricing ? 'included' : ''

  if (currencySymbolPlacement === 'start') {
    return `${text} ${isBundlePricingText}: ${currencySymbol}${amount} ${currency}`
  }

  return `${text} ${isBundlePricingText}: ${amount} ${currencySymbol} ${currency}`
}

export default TaxLine
